import React from 'react';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { Box } from '@material-ui/core';
import { formatUtc } from '../../../shared/utils';
import { UserRequestStatusIcon } from '../../icons/UserRequestStatusIcon';
import { getCategoryLabel } from './SupportRequestDetails/SupportRequestDetails';

export const buildSupportColumns = (
  formatDate: (dateIso?: string | null) => string = formatUtc,
): GridColDef[] => {
  return [
    {
      flex: 1,
      field: 'requestId',
      headerName: 'Request ID',
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => (
        <span>{params.row.requestId || params.row.id}</span>
      ),
    },
    {
      flex: 1.2,
      field: 'submittedAt',
      headerName: 'Date Submitted',
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => (
        <span>{formatDate(params.row.submittedAt)}</span>
      ),
    },
    {
      flex: 1,
      field: 'name',
      headerName: 'Name',
      disableColumnMenu: true,
    },
    {
      flex: 1,
      field: 'assignedAdmin',
      headerName: 'Assigned Admin',
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => (
        <span>{params.row?.assignedAdmin || '-'}</span>
      ),
    },
    {
      flex: 1,
      field: 'status',
      headerName: 'Status',
      disableColumnMenu: true,
      minWidth: 160,
      renderCell: (params: GridRenderCellParams) => (
        <Box style={{ display: 'flex', alignItems: 'center' }}>
          <UserRequestStatusIcon status={params.value} />
          <span style={{ marginLeft: 8 }}>{params.value}</span>
        </Box>
      ),
    },
    {
      flex: 1,
      field: 'category',
      headerName: 'Support Category',
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => (
        <span>{getCategoryLabel(params.row?.category)}</span>
      ),
    },
    {
      flex: 2,
      field: 'description',
      headerName: 'Brief Description',
      disableColumnMenu: true,
    },
    {
      flex: 2,
      field: 'resolutionComment',
      headerName: 'Resolution Comment',
      disableColumnMenu: true,
      renderCell: (params: GridRenderCellParams) => (
        <span>{params.row?.resolutionComment || '-'}</span>
      ),
    },
  ];
};
